import { t } from 'i18next';
import { JobsHeadCell } from './types';

export const jobsHeadCells: JobsHeadCell[] = [
  {
    id: 'code',
    numeric: false,
    label: t('job', { ns: 'job' }),
    align: 'left',
  },
  {
    id: 'customer',
    numeric: true,
    label: t('general.data.customer', { ns: 'job' }),
    align: 'left',
  },
  {
    id: 'etaEtd',
    numeric: true,
    label: t('estimation', { ns: 'job' }),
    align: 'left',
  },
  {
    id: 'description',
    numeric: true,
    label: t('description', { ns: 'misc' }),
    align: 'left',
  },
  {
    id: 'status',
    numeric: true,
    label: t('general.data.status', { ns: 'job' }),
    align: 'justify',
  },
];

export const jobStatusLabels = {
  IN_PROGRESS: t('general.data.statusLabels.IN_PROGRESS', { ns: 'job' }),
  FINALIZED: t('general.data.statusLabels.FINALIZED', { ns: 'job' }),
  BILLED: t('general.data.statusLabels.BILLED', { ns: 'job' }),
  CANCELLED: t('general.data.statusLabels.CANCELLED', { ns: 'job' }),
};
